<mat-card class="integration-custom-field-settings" appearance="outlined">
  <mat-card-content fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="40px">
    <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
      <mat-card-title style="padding-left: 0">Integration with {{ integrationTitle }}</mat-card-title>

      <div class="integration-custom-field-settings__info" fxLayout="row" fxLayoutAlign="start center">
        <label fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="30" fxFlex.sm="40" fxFlex.xs="50">Status</label>
        <div class="status-indicator" [ngClass]="{ active: integration.isActive }"></div>
      </div>

      <div class="integration-custom-field-settings__info" fxLayout="row" fxLayoutAlign="start center">
        <label fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="30" fxFlex.sm="40" fxFlex.xs="50">Last Sync Time</label>
        <span>{{ integration.lastSyncDate ? (integration.lastSyncDate | dateTime) : 'Never' }}</span>
      </div>

      <div class="integration-custom-field-settings__info" fxLayout="row" fxLayoutAlign="start center">
        <label fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="30" fxFlex.sm="40" fxFlex.xs="50">Sync Daily</label>
        <mat-checkbox
          style="margin-left: -11px"
          color="primary"
          [checked]="integration.syncInterval > 0"
          (change)="syncDailyUpdated(integration)"
        >
        </mat-checkbox>
      </div>

      <mat-accordion multi="false">
        <div *ngFor="let sectionGroup of customFieldSections?.controls; trackBy: trackByFn">
          <app-integration-custom-field-settings
            [sectionGroup]="$any(sectionGroup)"
            [integration]="integration"
            [submitted]="submitted"
            [canEditTags]="canEditTags"
          ></app-integration-custom-field-settings>
        </div>
      </mat-accordion>
    </div>

    <mat-card-actions>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <button
          *ngIf="hasEditAccess"
          mat-raised-button
          type="button"
          color="primary"
          matTooltip="Save changes"
          [promiseBtn]="buttonSubmitPromise"
          (click)="saveChanges($event, integration)"
        >
          Save
        </button>

        <app-long-task-button
          *ngIf="hasEditAccess && integration.isActive"
          [clickFunction]="syncNowTask.bind(this)"
          loadingColor="warn"
          tooltip="Sync Contacts Manually"
          buttonType="mini-fab"
          buttonTitle=""
          [taskKey]="getTaskKey()"
        ></app-long-task-button>

        <a
          *ngIf="hasEditAccess && !integration.isActive && integrationHasLogin"
          mat-stroked-button
          color="primary"
          matTooltip="Login to integration"
          [href]="integration.loginUrl"
        >
          Login
        </a>

        <button
          *ngIf="hasEditAccess && integration.isActive && integrationHasLogin"
          type="button"
          mat-stroked-button
          color="warn"
          matTooltip="Revoke google integration key"
          (click)="revokeToken($event, integration)"
        >
          Revoke
        </button>

        <button
          *ngIf="hasEditAccess && integration.isActive && !integrationHasLogin"
          type="button"
          mat-stroked-button
          color="warn"
          matTooltip="Deactivate integration"
          (click)="deactivateSyncIntegration(integration)"
        >
          Deactivate
        </button>
      </div>
    </mat-card-actions>
  </mat-card-content>
</mat-card>
